import { PeriodEnum } from '../../../enum/PeriodEnum';
import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export interface PeriodGranularityProps {
  value?: PeriodEnum | null;
  onClick: (period: PeriodEnum) => void;
  items?: { label: string; value: PeriodEnum }[];
  hasFullWidth?: boolean;
}
export default function PeriodGranularity({
  value = PeriodEnum.DAILY,
  hasFullWidth = false,
  items = [
    {
      label: PeriodEnum.getLabel(PeriodEnum.QUARTERLY),
      value: PeriodEnum.QUARTERLY,
    },
    {
      label: PeriodEnum.getLabel(PeriodEnum.HOURLY),
      value: PeriodEnum.HOURLY,
    },
    {
      label: PeriodEnum.getLabel(PeriodEnum.DAILY),
      value: PeriodEnum.DAILY,
    },
    {
      label: PeriodEnum.getLabel(PeriodEnum.WEEKLY),
      value: PeriodEnum.WEEKLY,
    },
    {
      label: PeriodEnum.getLabel(PeriodEnum.MONTHLY),
      value: PeriodEnum.MONTHLY,
    },
    {
      label: PeriodEnum.getLabel(PeriodEnum.YEARLY),
      value: PeriodEnum.YEARLY,
    },
  ],
  onClick,
}: PeriodGranularityProps) {
  const { t } = useTranslation();
  const valueIndex = items.findIndex((item) => item.value === value);
  const hasSeparator = (index: number) =>
    index !== valueIndex - 1 && index !== valueIndex && index !== items.length - 1;

  return (
    <ul
      className={classNames('period-granularity', {
        'period-granularity--full-width': hasFullWidth,
      })}
    >
      {items.map((period, index) => (
        <li
          key={period.value}
          data-test-id={`period-granularity-${period.value.toLowerCase()}-button`}
          className={classNames('period-granularity__item', {
            'period-granularity__item--active': period.value === value,
            'period-granularity__item--full-width': hasFullWidth,
          })}
          onClick={() => {
            onClick(period.value);
          }}
        >
          <span className="period-granularity__item__label">{t(period.label)}</span>
          {hasSeparator(index) && <div className="period-granularity__item__separator"></div>}
        </li>
      ))}
    </ul>
  );
}
